export default "__VITE_ASSET__CdIenRqh__"